export default __webpack_public_path__ + "static/media/Office.196ae638.png";